import type { StockDetailData } from "fin-web-components";
import { useLongfansMock } from "../../global/GlobalMock";
import { post } from "../../utils/Backend";
import { mockStockDetailByCode } from "./StockDetailMock";

const QUERY_STOCK_DETAIL_URL = "/lark/app/stock/queryStockDetailInfo";

export async function queryStockDetailInfoForLongfans(
  stockCode: string
): Promise<StockDetailData | null> {
  if (useLongfansMock) {
    return mockStockDetailByCode(stockCode.trim());
  }
  const r = await post<{ stockCode: string }, StockDetailData>(QUERY_STOCK_DETAIL_URL, {
    stockCode: stockCode.trim(),
  });
  if (typeof r === "string") {
    return null;
  }
  return r;
}
